// extracted by mini-css-extract-plugin
module.exports = {"root":"AdminDashBoard_root__2duve","dateRange":"AdminDashBoard_dateRange__3iGYe","hint":"AdminDashBoard_hint__1aYat","widgetsContainer":"AdminDashBoard_widgetsContainer__1MXg5"};